
const digest = '19c83eae05ee8a4f20fdb3e1ed2acb7770c4d2029e04174d8c9208f276a8e93e';
const classes = {"wrapper":"_wrapper_jm416_1","addUserWrapper":"_addUserWrapper_jm416_8","header":"_header_jm416_12","title":"_title_jm416_17","inputs":"_inputs_jm416_22","select":"_select_jm416_29","membersWrapper":"_membersWrapper_jm416_32","counter":"_counter_jm416_48","item":"_item_jm416_54","image":"_image_jm416_63","content":"_content_jm416_69","name":"_name_jm416_75","text":"_text_jm416_80","controls":"_controls_jm416_88"};
const css = `._wrapper_jm416_1 {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  overflow-y: hidden;
}
._wrapper_jm416_1 ._addUserWrapper_jm416_8 {
  padding: 24px;
  background-color: #f2f4f7;
}
._wrapper_jm416_1 ._addUserWrapper_jm416_8 ._header_jm416_12 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_jm416_1 ._addUserWrapper_jm416_8 ._header_jm416_12 ._title_jm416_17 {
  font-size: 18px;
  color: #000;
  font-weight: 500;
}
._wrapper_jm416_1 ._addUserWrapper_jm416_8 ._inputs_jm416_22 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 20px 0 0 0;
  align-items: flex-end;
}
._wrapper_jm416_1 ._addUserWrapper_jm416_8 ._inputs_jm416_22 ._select_jm416_29 {
  flex: 1;
}
._wrapper_jm416_1 ._membersWrapper_jm416_32 {
  flex-grow: 1;
  overflow-y: hidden;
  padding: 24px;
}
._wrapper_jm416_1 ._membersWrapper_jm416_32 ._header_jm416_12 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 15px;
}
._wrapper_jm416_1 ._membersWrapper_jm416_32 ._header_jm416_12 ._title_jm416_17 {
  font-size: 18px;
  color: #000;
  font-weight: 500;
}
._wrapper_jm416_1 ._membersWrapper_jm416_32 ._header_jm416_12 ._counter_jm416_48 {
  font-size: 14px;
  color: #1d65d8;
  font-weight: 500;
}

._item_jm416_54 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e9e9e9;
  padding-bottom: 20px;
}
._item_jm416_54 ._image_jm416_63 {
  height: 35px;
  width: 35px;
  object-fit: cover;
  border-radius: 100%;
}
._item_jm416_54 ._content_jm416_69 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 5px;
}
._item_jm416_54 ._content_jm416_69 ._name_jm416_75 {
  font-weight: 500;
  font-size: 16px;
  color: #000;
}
._item_jm416_54 ._content_jm416_69 ._text_jm416_80 {
  font-weight: 400;
  font-size: 14px;
  color: #000;
}
._item_jm416_54 ._content_jm416_69 ._text_jm416_80 span {
  color: #9ea0a5;
}
._item_jm416_54 ._controls_jm416_88 {
  padding-right: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  